import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01844190"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "testimonial-slider" }
const _hoisted_2 = { class: "testimonial-wrapper" }
const _hoisted_3 = { class: "name" }
const _hoisted_4 = { class: "text" }
const _hoisted_5 = { class: "mobile-controls" }
const _hoisted_6 = { class: "nav-buttons" }
const _hoisted_7 = { class: "pagination" }

import { ref, computed, onMounted, onUnmounted } from 'vue'
import { useI18n } from 'vue-i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'Testimonials',
  setup(__props) {

const { t } = useI18n()

const testimonials = computed(() => [
  {
    name: t('landingMTClickbait.testimonials.reviews.review_1.name'),
    text: t('landingMTClickbait.testimonials.reviews.review_1.review'),
  },
  {
    name: t('landingMTClickbait.testimonials.reviews.review_2.name'),
    text: t('landingMTClickbait.testimonials.reviews.review_2.review'),
  },
  {
    name: t('landingMTClickbait.testimonials.reviews.review_3.name'),
    text: t('landingMTClickbait.testimonials.reviews.review_3.review'),
  },
  {
    name: t('landingMTClickbait.testimonials.reviews.review_4.name'),
    text: t('landingMTClickbait.testimonials.reviews.review_4.review'),
  },
  {
    name: t('landingMTClickbait.testimonials.reviews.review_5.name'),
    text: t('landingMTClickbait.testimonials.reviews.review_5.review'),
  },
  {
    name: t('landingMTClickbait.testimonials.reviews.review_6.name'),
    text: t('landingMTClickbait.testimonials.reviews.review_6.review'),
  },
])

const currentIndex = ref(0)
const windowWidth = ref(window.innerWidth)

const updateWindowWidth = () => {
  windowWidth.value = window.innerWidth
}

onMounted(() => {
  updateWindowWidth()
  window.addEventListener('resize', updateWindowWidth)
})

onUnmounted(() => {
  window.removeEventListener('resize', updateWindowWidth)
})

const itemsToShow = computed(() => {
  return windowWidth.value < 768 ? 1 : 3
})

const visibleTestimonials = computed(() => {
  return testimonials.value.slice(
    currentIndex.value,
    currentIndex.value + itemsToShow.value,
  )
})

const next = () => {
  const maxIndex = testimonials.value.length - itemsToShow.value
  currentIndex.value = Math.min(
    currentIndex.value + itemsToShow.value,
    maxIndex,
  )
}

const prev = () => {
  currentIndex.value = Math.max(currentIndex.value - itemsToShow.value, 0)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      onClick: prev,
      class: "nav left desktop-nav"
    }, "←"),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleTestimonials.value, (testimonial, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "testimonial",
          key: index
        }, [
          _createElementVNode("h2", _hoisted_3, _toDisplayString(testimonial.name), 1),
          _createElementVNode("p", _hoisted_4, _toDisplayString(testimonial.text), 1)
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          onClick: prev,
          class: "nav left"
        }, "←"),
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Math.ceil(testimonials.value.length / itemsToShow.value), (_, index) => {
            return (_openBlock(), _createElementBlock("span", {
              key: index,
              class: _normalizeClass({
              dot: true,
              active: index === Math.floor(currentIndex.value / itemsToShow.value),
            })
            }, null, 2))
          }), 128))
        ]),
        _createElementVNode("button", {
          onClick: next,
          class: "nav right"
        }, "→")
      ])
    ]),
    _createElementVNode("button", {
      onClick: next,
      class: "nav right desktop-nav"
    }, "→")
  ]))
}
}

})